var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "100px",
    height: "100px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.59473,46.77734a8.00066,8.00066,0,0,1,1.95215-12.32812A79.89269,79.89269,0,0,1,128.6084,24.002c43.66894.32422,79.19629,36.61719,79.19629,80.90235V112c0,21.85059,2.84179,40.14844,8.44531,54.38672a8.00047,8.00047,0,0,1-13.36426,8.31152ZM213.91992,210.61816a8.0006,8.0006,0,0,1-11.83984,10.76368L182.64209,200H168a40,40,0,0,1-80,0H48.9834a15.99886,15.99886,0,0,1-13.79688-24.06445C41.124,165.7207,48.20312,146.33594,48.20312,112v-8A79.70131,79.70131,0,0,1,58.93164,63.91846L42.08008,45.38184A8.0006,8.0006,0,1,1,53.91992,34.61816ZM152,200H104a24,24,0,0,0,48,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribe);
export default __webpack_public_path__ + "static/media/unsubscribe.d31056c4cc38ef07c10e63ce55e22899.svg";
export { ForwardRef as ReactComponent };